export default {"src":"/_next/static/media/brokenlinkLarge.24d9e78f.svg","height":84,"width":150};